import {
  ZoneOffset as ZoneOffset,
  ZoneId as ZoneId,
  LocalDateTime as LocalDateTime,
} from '@js-joda/core';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  UtcOffset17lxgyhnn4rny as UtcOffset,
  asTimeZone3kdzfpoilmjbj as asTimeZone,
} from './UtcOffset.mjs';
import {
  IllegalTimeZoneException2q01rvpc2etsw as IllegalTimeZoneException,
  DateTimeArithmeticException3b9ehoczpp1e2 as DateTimeArithmeticException,
} from './Exceptions.mjs';
import {
  isJodaDateTimeException2l3lhdyy3jadv as isJodaDateTimeException,
  isJodaArithmeticExceptionwen50fdrku5h as isJodaArithmeticException,
} from './JSJodaExceptions.mjs';
import { getAvailableZoneIdsSet2qkom0nd2ncgs as getAvailableZoneIdsSet } from './internal/PlatformSpecifics.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  TimeZoneSerializer_getInstanceqa9aveo7y5x8 as TimeZoneSerializer_getInstance,
  FixedOffsetTimeZoneSerializer_getInstance1l46ueoee8ix3 as FixedOffsetTimeZoneSerializer_getInstance,
} from './serializers/TimeZoneSerializers.mjs';
import { LocalDateTime3vqv9moe7clf4 as LocalDateTime_0 } from './LocalDateTime.mjs';
import { Instant3cn81rq2kpflk as Instant } from './Instant.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ofZone($this, zoneId) {
  var tmp;
  if (zoneId instanceof ZoneOffset) {
    tmp = FixedOffsetTimeZone().d1p(new (UtcOffset())(zoneId));
  } else {
    if (zoneId.rules().isFixedOffset()) {
      var tmp_0 = zoneId.normalized();
      tmp = FixedOffsetTimeZone().n27(new (UtcOffset())(tmp_0 instanceof ZoneOffset ? tmp_0 : THROW_CCE()), zoneId);
    } else {
      tmp = TimeZone().m27(zoneId);
    }
  }
  return tmp;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.a26_1 = asTimeZone(new (UtcOffset())(ZoneOffset.UTC));
      }
      o27() {
        return ofZone(this, ZoneId.systemDefault());
      }
      b26(zoneId) {
        var tmp;
        try {
          // Inline function 'kotlinx.datetime.jsTry' call
          var tmp$ret$1 = ZoneId.of(zoneId);
          tmp = ofZone(this, tmp$ret$1);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Error) {
            var e = $p;
            if (isJodaDateTimeException(e))
              throw IllegalTimeZoneException().f1o(e);
            throw e;
          } else {
            throw $p;
          }
        }
        return tmp;
      }
      p27() {
        return getAvailableZoneIdsSet();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var TimeZoneClass;
function TimeZone() {
  if (TimeZoneClass === VOID) {
    class $ {
      static m27(zoneId) {
        Companion_getInstance();
        var $this = createThis(this);
        $this.d26_1 = zoneId;
        return $this;
      }
      e26() {
        return this.d26_1.id();
      }
      equals(other) {
        var tmp;
        if (this === other) {
          tmp = true;
        } else {
          var tmp_0;
          if (other instanceof TimeZone()) {
            tmp_0 = this.d26_1 === other.d26_1 || this.d26_1.equals(other.d26_1);
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      hashCode() {
        return this.d26_1.hashCode();
      }
      toString() {
        return this.d26_1.toString();
      }
    }
    initMetadataForClass($, 'TimeZone', VOID, VOID, VOID, VOID, VOID, {0: TimeZoneSerializer_getInstance});
    TimeZoneClass = $;
  }
  return TimeZoneClass;
}
function toLocalDateTime(_this__u8e3s4, timeZone) {
  var tmp;
  try {
    // Inline function 'kotlinx.datetime.jsTry' call
    // Inline function 'kotlin.let' call
    var p0 = LocalDateTime.ofInstant(_this__u8e3s4.l1s_1, timeZone.d26_1);
    tmp = LocalDateTime_0().b27(p0);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      if (isJodaDateTimeException(e))
        throw DateTimeArithmeticException().k1o(e);
      throw e;
    } else {
      throw $p;
    }
  }
  return tmp;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var FixedOffsetTimeZoneClass;
function FixedOffsetTimeZone() {
  if (FixedOffsetTimeZoneClass === VOID) {
    class $ extends TimeZone() {
      static n27(offset, zoneId) {
        var $this = this.m27(zoneId);
        $this.c1p_1 = offset;
        return $this;
      }
      static d1p(offset) {
        return this.n27(offset, offset.j1s_1);
      }
    }
    initMetadataForClass($, 'FixedOffsetTimeZone', VOID, VOID, VOID, VOID, VOID, {0: FixedOffsetTimeZoneSerializer_getInstance});
    FixedOffsetTimeZoneClass = $;
  }
  return FixedOffsetTimeZoneClass;
}
function offsetAt(_this__u8e3s4, instant) {
  var tmp;
  try {
    // Inline function 'kotlinx.datetime.jsTry' call
    // Inline function 'kotlin.let' call
    var p0 = _this__u8e3s4.d26_1.rules().offsetOfInstant(instant.l1s_1);
    tmp = new (UtcOffset())(p0);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      if (isJodaArithmeticException(e))
        throw DateTimeArithmeticException().k1o(e);
      throw e;
    } else {
      throw $p;
    }
  }
  return tmp;
}
function toInstant(_this__u8e3s4, offset) {
  // Inline function 'kotlin.let' call
  var p0 = _this__u8e3s4.s1o_1.toInstant(offset.j1s_1);
  return new (Instant())(p0);
}
function toInstant_0(_this__u8e3s4, timeZone) {
  // Inline function 'kotlin.let' call
  var p0 = _this__u8e3s4.s1o_1.atZone(timeZone.d26_1).toInstant();
  return new (Instant())(p0);
}
//region block: init
Companion_instance_0 = new (Companion_0())();
//endregion
//region block: exports
export {
  Companion_getInstance as Companion_getInstance3qu5ydsg8audm,
  FixedOffsetTimeZone as FixedOffsetTimeZone3oldrgkltiv4z,
  TimeZone as TimeZone3oibfp0mqo4lg,
  offsetAt as offsetAtp6wlf8rffh6g,
  toInstant as toInstant2lllz720612kd,
  toInstant_0 as toInstant2q17i3aluy6ks,
  toLocalDateTime as toLocalDateTime3u4c8ydzr4ubp,
};
//endregion

//# sourceMappingURL=TimeZone.mjs.map
